export default __webpack_public_path__ + "static/logo__bundesliga-52888caf3e78144de0ab7e1b16217f67.svg";